import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
  position: relative; */
  /* display: grid;
  grid-template-columns: 1fr 1fr; */
  .carousel-img-container {
    position: relative;
    /* height: 104%; */
  }
  .ptplusModal{
    background-color:"red"
  }
 
  .carousel-img {
    height: auto;
    aspect-ratio: auto 1440/734;
    width:100vw;
    max-width:1440px
    
  }
  .text-box-heading {
    position: absolute;
    top: 15%;
    left: 11%;
  }
  h2 {
    color: #fff;
    font-weight: 600;
    font-size: min(2.24vw, 32px);
    line-height: min(3.15vw, 45px);
    font-family: "robotoblack";
    margin: 0;
    letter-spacing: 2.43px;
  }
  .text-box-subheading {
    position: absolute;
    top: 30%;
    left: 11%;
  }
  h6 {
    color: #fff;
    font-size: min(1.26vw, 18px);
    line-height: min(1.75vw, 25px);
    font-family: "robotoblack";
    margin: 0;
    letter-spacing: 1.43px;
  }
  .tell-more-btn {
    position: absolute;
    top: 61%;
    left: 11%;

    background-color: #fff;
    color: #0a5587;
    width: min(15.13vw, 189px);
    height: min(2.73vw, 39px);
    font-size: min(1.19vw, 17px);
    border-radius: min(0.42vw, 6px);
    border: none;
    cursor: pointer;
    font-family: "robotoregular";
    margin-top: min(1.75vw, 25px);
  }
  .mobile-view-loading-page {
    display: none;
  }
  > div {
    flex: 1;
  }
  
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding: 0px;
    .carousel-img-container {
      height: auto;
    }
    .carousel-img {
      width: 100%;
      height: auto;
    }
    .text-box-heading {
      left: 8%;
    }
    .text-box-subheading {
      left: 8%;
    }
    /* .tell-more-btn {
      left: 18%;
      font-size: 10px;
      padding: 3px 14px;
    } */
    .mobile-view-loading-page {
      display: block;
      width: 94.138vw;
    }

    
  }
`;

export { Container, Wrapper };

